import { useEffect, useState } from 'react'
import { callApi } from '@/utils/http-utils'

type AnyRecord = Record<string, any>

export const useModality = (limit = 10, offset = 0) => {
  const [data, setData] = useState<AnyRecord[]>([])
  const [totalCount, setTotalCount] = useState<number>(0)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    ;(async () => {
      try {
        setLoading(true)
        setError('')
        const res = await callApi(`/data-api/modalities?limit=${limit}&offset=${offset}`, { method: 'GET' })
        const ct = res.headers.get('content-type') || ''
        if (!ct.includes('application/json')) {
          const text = await res.text()
          throw new Error(`Expected JSON but got ${ct}. ${text.slice(0, 200)}`)
        }
        const body = await res.json()
        const rows = Array.isArray(body) ? body : body.items || body.data || body.results || []
        setData(rows)
        // Extract totalCount from response body
        setTotalCount(body.totalCount || rows.length)
      } catch (e: any) {
        setError(e.message || 'Failed to fetch modalities')
      } finally {
        setLoading(false)
      }
    })()
  }, [limit, offset])

  return { data, totalCount, loading, error }
}
